import { Progress, Button } from "@dreambigger/design-system/src/components";
import { FinancialBrand } from "@dreambigger/shared/src/types";
import { optimizeCloudinaryImg } from "@dreambigger/shared/src/utils";
import { LeftOutlined } from "@ant-design/icons";

interface StepContentLogoProgressProps {
  brand: FinancialBrand;
  stepProgress: number;
  previousSlug?: string;
  hideProgressBar?: boolean;
  handleClick: () => void;
  trackAnalytics: () => void;
}

const StepContentLogoProgress = ({
  brand,
  stepProgress,
  previousSlug,
  hideProgressBar,
  handleClick,
  trackAnalytics,
}: StepContentLogoProgressProps) => {
  return (
    <div className="flex flex-column lg_flex-row items-center lg_justify-between mb-6">
      {/* Logo - centered on mobile, left on desktop */}
      {brand.primaryLogo &&
        (brand.primaryLogoUrl ? (
          <a
            href={brand.primaryLogoUrl}
            target="_blank"
            rel="noreferrer"
            onClick={trackAnalytics}
          >
            <img
              src={optimizeCloudinaryImg(brand.primaryLogo)}
              alt="logo"
              style={{
                height:
                  brand.acquireLogoHeight ||
                  brand.primaryLogoHeight ||
                  "24px",
                width: "auto",
                objectFit: "contain",
              }}
            />
          </a>
        ) : (
          <img
            src={optimizeCloudinaryImg(brand.primaryLogo)}
            alt="logo"
            style={{
              height:
                brand.acquireLogoHeight ||
                brand.primaryLogoHeight ||
                "24px",
              width: "auto",
              objectFit: "contain",
            }}
          />
        ))}

      {/* Back button + progress bar - below logo on mobile, right on desktop.
          The back button is shown whenever a previousSlug exists;
          hideProgressBar only hides the bar itself, and with the bar gone the
          button sits at the right edge of the row. */}
      {(previousSlug || !hideProgressBar) && (
        <div className="flex items-center mt-4 lg_mt-0" style={{ gap: "8px" }}>
          {previousSlug && (
            <Button
              type="primary"
              onClick={handleClick}
              className="bg-black white bn br-100 pa-0 lift"
              style={{
                width: "28px",
                height: "28px",
              }}
            >
              <LeftOutlined className="white f-2" />
            </Button>
          )}
          {!hideProgressBar && (
            <>
              <Progress
                style={{ width: "180px" }}
                trailColor="#e3e1e1"
                strokeColor={brand.primaryColor}
                percent={stepProgress}
                showInfo={false}
              />
              <span className="fwb gray-7 f-3">{stepProgress}%</span>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default StepContentLogoProgress;
